<template>
    <div class="attactpanel" v-if="attachCfg.fkvalue">
        <a-spin :spinning="spinning">
            <div class="title">
                <div class="attachtitle">
                    附件浏览
                </div>
                <a @click="packageDownload"><a-icon type="file-zip"/></a>
            </div>

            <div class="attachserch"><a-input-search v-model="searchvalue" placeholder="请输入文件名" style="width: 100%;" @search="onSearch" /></div>
            <div class="attachfilelist">
                <a-tree
                    v-model="checkedKeys"
                    :replaceFields="{ children: 'children', title: 'filename', key: 'control_no' }"
                    :tree-data="treeData"
                    :show-line="true"
                    :defaultExpandAll="true"
                    :expanded-keys="expandedKeys"
                    @expand="onExpand"
                    @rightClick="onRightClick"
                />
                <v-contextmenu ref="contextmenu_down">
                    <v-contextmenu-item @click="handlePreview"><a-icon type="link" />预览</v-contextmenu-item>
                    <v-contextmenu-item @click="handleDownload"><a-icon type="download" />下载</v-contextmenu-item>
                </v-contextmenu>
            </div>
        </a-spin>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "AttachDownload",
    props: ["attachCfg"],
    data() {
        return {
            queryParams: {},
            searchvalue: "",
            fileList: [],
            treeData: [], //树形数据
            checkedKeys: [],
            selectedKeys: [],
            expandedKeys: [],
            file: {},
            spinning: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"])
    },
    watch: {
        attachCfg: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                this.treeData = [];
                if (newVal.fkvalue) {
                    this.queryAttachFileList();
                }
            },
            immediate: true,
            deep: true
        }
    },
    activated() {
        this.fileList = [];
    },
    methods: {
        queryAttachFileList() {
            this.$FG_http
                .post(
                    "./api/main/attach/queryAttach",
                    {
                        queryParams: this.attachCfg
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.fileList = data.data.attach;
                            this.treeData = data.data.tree;
                            if (this.treeData.length > 0) {
                                this.expandedKeys.push(this.treeData[0].control_no);
                            }
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002");
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.$FG_message.error("P0002");
                    }
                });
        },
        packageDownload() {
            this.spinning = true;
            this.$FG_http
                .post(
                    "./api/main/attach/packageDownload",
                    {
                        queryParams: this.attachCfg
                    },
                    {
                        responseType: "blob",
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg, response }) => {
                    this.spinning = false;
                    if (success) {
                        try {
                            // 获取文件名fileName
                            let fileName = response.headers["content-disposition"].split("=");
                            fileName = fileName[fileName.length - 1];
                            fileName = decodeURI(fileName.replace(/"/g, ""));
                            let aLink = document.createElement("a");
                            let blob = new Blob([data]);
                            aLink.href = URL.createObjectURL(blob);
                            aLink.setAttribute("download", fileName); // 设置下载文件名称
                            aLink.click(); //执行下载
                            document.body.appendChild(aLink);
                            URL.revokeObjectURL(aLink.href); //释放url
                            document.body.removeChild(aLink); //释放标签
                        } catch (e) {
                            this.$FG_message.error("打包失败，没有获取到附件！");
                        }
                    }
                });
        },
        onSearch() {
            this.fileList = [];
            this.attachCfg.filename = this.searchvalue;
            this.queryAttachFileList();
        },
        onExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
        },
        onRightClick({ event, node }) {
            const file_type = node._props.dataRef.file_type;
            if (file_type === 1) {
                this.$refs.contextmenu_down.hide();
                return;
            }
            this.file = {
                uid: node._props.dataRef.id,
                name: node._props.dataRef.filename
            };
            const x = event.x; //event.screenX - 300 + event.currentTarget.clientWidth + 50;
            // 因为我放在页面上的box有滚动条，所以需要减掉该盒子的scrollTop
            const y = event.y; //event.currentTarget.offsetHeight + event.currentTarget.offsetTop + 150;
            const postition = {
                top: y,
                left: x
            };
            this.$refs.contextmenu_down.show(postition);
        },
        handlePreview() {
            this.$FG_http
                .post(
                    "./api/main/attach/previewAttach",
                    {
                        id: this.file.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        this.file.url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(this.file.url, this.file.name);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        handleDownload() {
            this.$FG_http
                .post(
                    "./api/main/attach/downloadAttach",
                    {
                        id: this.file.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let aLink = document.createElement("a");
                        let blob = new Blob([data]);
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", this.file.name); // 设置下载文件名称
                        aLink.click(); //执行下载
                        document.body.appendChild(aLink);
                        URL.revokeObjectURL(aLink.href); //释放url
                        document.body.removeChild(aLink); //释放标签

                        // 更新下载此时
                        this.$emit("updateDownload");
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.attactpanel {
    padding: 5px 10px;
    display: flex;
    flex-flow: column;

    .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
    }

    .attachtitle {
        color: #333;
        font-size: 24px;
        font-weight: bold;
    }
    .attachserch {
        margin: 1em 0 0.5em 0;
    }
    .attachbtn {
        text-align: right;
    }
    .attachfilelist {
        margin: 10px 0;
    }
}
</style>
